// extracted by mini-css-extract-plugin
module.exports = {"brand-reliability":"BrandReliability_brand-reliability__BQtCQ"};